import { uploadConstants } from '../constants'

const initialState = {
  queue: [],
  listening: false,
  uploading: false,
  loading: false
}

export default function upload (state = initialState, action) {
  switch (action.type) {
    case uploadConstants.UPLOAD_ADD_FILE_TO_QUEUE:
      return {
        ...state,
        queue: state.queue.concat(action.payload)
      }
    case uploadConstants.UPLOAD_UPDATE_QUEUE:
      return {
        ...state,
        queue: state.queue.map((x) => {
          return (x._id !== action.payload._id)
            ? x
            : { ...x,
              chunks: x.chunks.concat({
                size: action.payload.chunk_size,
                status: action.payload.status
              })
            }
        })
      }
    case uploadConstants.UPLOAD_CHUNK_FILE_TO_QUEUE:
      return {
        ...state,
        queue: state.queue.findIndex(x => x._id === action.payload._id) === -1
          ? state.queue.concat({
            _id: action.payload._id,
            name: action.payload.name,
            size: action.payload.size,
            chunks: [{
              size: action.payload.size,
              status: action.payload.status
            }]
          })
          : state.queue.map(x => {
            return x._id !== action.payload._id
              ? x
              : { ...x,
                chunks: x.chunks.concat({
                  size: action.payload.chunk_size,
                  status: action.payload.status
                })
              }
          })
      }
    case uploadConstants.UPLOAD_START_UPLOAD:
      return { ...state, uploading: true }
    case uploadConstants.UPLOAD_END_UPLOAD:
      return { ...state,
        uploading: false,
        queue: state.queue.filter(x => x._id !== action.payload._id)
      }
    case uploadConstants.UPLOAD_PROCESSING:
      return { ...state, loading: true }
    case uploadConstants.UPLOAD_END_PROCESSING:
      return { ...state, loading: false }
    default:
      return state
  }
}
